var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_4178651",
    clipPath: "url(#clip0_424_14147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Live_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.8359 17.0156H3.16406C1.41933 17.0156 0 18.435 0 20.1797V32.8359C0 34.5807 1.41933 36 3.16406 36H32.8359C34.5807 36 36 34.5807 36 32.8359V20.1797C36 18.435 34.5807 17.0156 32.8359 17.0156ZM9.5625 31.7812H5.34375C4.76079 31.7812 4.28906 31.3095 4.28906 30.7266V22.2891C4.28906 21.7061 4.76079 21.2344 5.34375 21.2344C5.92671 21.2344 6.39844 21.7061 6.39844 22.2891V29.6719H9.5625C10.1455 29.6719 10.6172 30.1436 10.6172 30.7266C10.6172 31.3095 10.1455 31.7812 9.5625 31.7812ZM14.8359 30.7266C14.8359 31.3095 14.3642 31.7812 13.7812 31.7812C13.1983 31.7812 12.7266 31.3095 12.7266 30.7266V22.2891C12.7266 21.7061 13.1983 21.2344 13.7812 21.2344C14.3642 21.2344 14.8359 21.7061 14.8359 22.2891V30.7266ZM23.2415 22.5445L21.1321 30.982C21.0147 31.4517 20.5935 31.7812 20.1094 31.7812C19.6253 31.7812 19.204 31.4516 19.0866 30.982L16.9772 22.5445C16.8351 21.9801 17.1791 21.4074 17.7446 21.2663C18.308 21.12 18.8816 21.4682 19.0228 22.0336L20.1094 26.3781L21.196 22.0337C21.336 21.4682 21.9087 21.1191 22.4742 21.2664C23.0396 21.4074 23.3837 21.9801 23.2415 22.5445ZM30.6562 25.4531C31.2392 25.4531 31.7109 25.9249 31.7109 26.5078C31.7109 27.0908 31.2392 27.5625 30.6562 27.5625H27.4922V29.6719H30.6562C31.2392 29.6719 31.7109 30.1436 31.7109 30.7266C31.7109 31.3095 31.2392 31.7812 30.6562 31.7812H26.4375C25.8545 31.7812 25.3828 31.3095 25.3828 30.7266V22.2891C25.3828 21.7061 25.8545 21.2344 26.4375 21.2344H30.6562C31.2392 21.2344 31.7109 21.7061 31.7109 22.2891C31.7109 22.872 31.2392 23.3438 30.6562 23.3438H27.4922V25.4531H30.6562Z",
    fill: "#D90000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.71785 14.3444C5.64027 10.2451 5.64027 4.52053 8.71785 0.42124C9.06702 -0.0432447 9.7293 -0.139081 10.1948 0.211146C10.6604 0.561372 10.7541 1.22259 10.4049 1.68813C7.88669 5.0407 7.88669 9.72499 10.4049 13.0775C10.7541 13.543 10.6604 14.2042 10.1948 14.5545C9.73127 14.9022 9.06871 14.8121 8.71785 14.3444Z",
    fill: "#D90000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.8049 14.5545C25.3394 14.2043 25.2457 13.543 25.5948 13.0775C28.1131 9.72492 28.1131 5.04063 25.5948 1.68814C25.2457 1.2226 25.3394 0.561377 25.8049 0.211151C26.2705 -0.138021 26.9338 -0.0432398 27.2819 0.421245C30.3595 4.52053 30.3595 10.2451 27.2819 14.3444C26.9316 14.8114 26.2694 14.9028 25.8049 14.5545Z",
    fill: "#D90000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.4971 12.305C9.98403 9.49943 9.98403 5.26627 12.4971 2.46059C12.8865 2.02697 13.556 1.99195 13.9865 2.37818C14.4201 2.76645 14.4572 3.43392 14.0689 3.86754C12.2747 5.87187 12.2747 8.89376 14.0689 10.8981C14.4572 11.3317 14.4201 11.9991 13.9865 12.3874C13.5544 12.7752 12.8858 12.7399 12.4971 12.305Z",
    fill: "#D90000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.0136 12.3875C21.58 11.9992 21.543 11.3317 21.9312 10.8981C23.7255 8.89377 23.7255 5.87188 21.9312 3.86755C21.543 3.43393 21.58 2.76653 22.0136 2.37819C22.4462 1.99091 23.1147 2.02592 23.503 2.4606C26.0161 5.26621 26.0161 9.49937 23.503 12.305C23.1144 12.7398 22.4458 12.7753 22.0136 12.3875Z",
    fill: "#D90000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18 10.5469C16.2553 10.5469 14.8359 9.12755 14.8359 7.38281C14.8359 5.63808 16.2553 4.21875 18 4.21875C19.7447 4.21875 21.1641 5.63808 21.1641 7.38281C21.1641 9.12755 19.7448 10.5469 18 10.5469Z",
    fill: "#D90000"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_424_14147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.08128803d69ec8cc3866fa5d3c98b0fb.svg";
export { ForwardRef as ReactComponent };